<template>
  <div>
    <label class="regra-modal__rotulo">Adicionar produto</label>
    <SeletorBusca
      class="mb-3"
      :value="produtoEscolhido"
      :opcoes="opcoesProdutos"
      placeholder="Busque por código, descrição ou código de barras"
      aria-label="Adicionar produto"
      texto-vazio="Nenhum produto encontrado"
      :erro="erroCarga"
      @abrir="$emit('recarregar')"
      @change="aoEscolherProduto"
    />
    <div class="regra-modal__caixa">
      <div class="regra-modal__caixa-cabecalho">
        <strong>Produtos selecionados</strong>
        <span>{{ produtosSelecionados.length }}</span>
      </div>
      <div class="regra-negocio-produtos__selecionados">
        <table class="regra-negocio-produtos__tabela">
          <thead>
            <tr>
              <th>Produto</th>
              <th v-if="!hideQtd" class="regra-negocio-produtos__col-qtd">Qtd. mínima</th>
              <th v-if="!hideQtd" class="regra-negocio-produtos__col-qtd">Qtd. máxima</th>
              <th class="regra-negocio-produtos__col-acao"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!produtosSelecionados.length">
              <td :colspan="hideQtd ? 2 : 4" class="regra-negocio-produtos__vazio">Nenhum produto selecionado</td>
            </tr>
            <tr v-for="(i, index) in produtosSelecionados" :key="`${i.produto_id}-${index}`">
              <td>
                <strong>{{ i.produto_id }}</strong>
                <div class="regra-negocio-produtos__descricao">{{ i.descricao }}</div>
              </td>
              <td v-if="!hideQtd">
                <input class="form-control form-control-sm" v-model="i.qtd_min" maxlength="30" type="number" aria-label="Quantidade mínima" />
              </td>
              <td v-if="!hideQtd">
                <input class="form-control form-control-sm" v-model="i.qtd_max" maxlength="30" type="number" aria-label="Quantidade máxima" />
              </td>
              <td class="regra-negocio-produtos__col-acao">
                <CButton
                  size="sm"
                  color="danger"
                  variant="ghost"
                  title="Remover"
                  :aria-label="`Remover ${i.descricao}`"
                  @click="deselectItem(i, index)"
                >
                  <fa-icon icon="trash-alt" />
                </CButton>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SeletorBusca from "@/components/form/SeletorBusca.vue";

export default {
  name: "multiselectable",
  components: { SeletorBusca },
  props: ["regra", "produtos", "produtosSelecionados", "selectCallback", "deselectCallback", "hideQtd", "erroCarga"],

  data() {
    return {
      produtoEscolhido: null,
    };
  },

  computed: {
    opcoesProdutos() {
      return (this.produtos || [])
        .filter((item) => !this.produtosSelecionados.some((selected) => `${selected.produto_id}` === `${item.id}`))
        .map((item) => ({ id: item.id, descricao: item.descComp, busca: item.codBar || "", produto: item }));
    },
  },

  methods: {
    aoEscolherProduto(valor, opcao) {
      this.produtoEscolhido = valor;

      if (opcao && opcao.produto) this.selectItem(opcao.produto);

      this.$nextTick(() => {
        this.produtoEscolhido = null;
      });
    },

    selectItem(item) {
      const newItem = {
        produto_id: item.id,
        descricao: item.descComp,
        qtd_min: item.qtd_min || 1,
        qtd_max: item.qtd_max || 1,
      };

      this.selectCallback(newItem);
    },

    deselectItem(item) {
      this.deselectCallback(item["produto_id"]);
    },
  },
};
</script>

<style scoped src="@/components/regras/regra-modal.css"></style>

<style scoped>






.regra-negocio-produtos__selecionados {
  max-height: 318px;
  overflow: auto;
}

.regra-negocio-produtos__tabela {
  width: 100%;
  border-collapse: collapse;
}

.regra-negocio-produtos__tabela th {
  padding: 8px 10px;
  border-bottom: 1px solid #eaecf0;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  white-space: nowrap;
}

.regra-negocio-produtos__tabela td {
  padding: 8px 10px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.regra-negocio-produtos__descricao {
  font-size: 12px;
  color: #667085;
}

.regra-negocio-produtos__col-qtd {
  width: 110px;
}

.regra-negocio-produtos__col-acao {
  width: 44px;
  text-align: center;
}

.regra-negocio-produtos__vazio,
.regra-negocio-produtos__tabela td.regra-negocio-produtos__vazio {
  padding: 24px 14px;
  text-align: center;
  font-size: 12.5px;
  color: #98a2b3;
}
</style>
